<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row>
          <div class="flex-bw">
            <el-form :inline="true" :model="searchCondition">
              <el-form-item label="">
                <el-input
                  v-model="searchCondition.search"
                  placeholder="请输入关键词"
                  clearable
                  @keyup.enter.native="searchButton"
                ></el-input>
              </el-form-item>
              <el-form-item label="服务商">
                <el-select
                  :placeholder="'请选择服务商'"
                  clearable
                  v-model="searchCondition.channel_name"
                >
                  <el-option
                    v-for="item in channelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="报送状态">
                <el-select clearable v-model="searchCondition.status">
                  <el-option
                    v-for="item in declareStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="人员验证状态">
                <el-select clearable v-model="searchCondition.real_status">
                  <el-option
                    v-for="item in verifyStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="时间">
                <el-date-picker
                  :picker-options="{
                    disabledDate,
                  }"
                  format="yyyy 年 MM 月"
                  value-format="yyyy-MM"
                  v-model="searchCondition.date"
                  type="month"
                  placeholder="选择月"
                  :clearable="false"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button @click="searchButton" style="color: #1890ff"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-row>
        <el-row class="export-box">
          <div class="flex-bw">
            <div class="btn-box">
              <el-button @click="sbao" type="primary">一键报送</el-button>
              <el-button @click="zuofei" type="danger">作废</el-button>
            </div>
            <div>
              <el-select
                v-model="value"
                placeholder="请选择导出类型"
                @change="selectData"
                class="select-box"
                size="medium"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button
                :loading="downloadLoading"
                style="margin: 0 0 20px 20px"
                type="primary"
                size="medium"
                icon="el-icon-document"
                @click="handleDownload"
              >
                导出
              </el-button>
            </div>
          </div>
        </el-row>

        <ApeTable
          ref="apeTable"
          :data="companyList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          @selectList="handleSelectionChange"
          highlight-current-row
        >
          <el-table-column
						slot="first-column"
            type="selection"
            width="55"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="120"
            header_align="center"
            align="center"
            label="报送状态"
          >
            <template slot-scope="scope">
              <span>{{ getDeclareLabel(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            header_align="center"
            align="center"
            label="人员验证状态"
          >
            <template slot-scope="scope">
              <span>{{ getVerifyLabel(scope.row.real_status) }}</span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import { debounce } from "@/utils/utils.js";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
  },
  data() {
    return {
      // 允许显示的字段
      allowField: ["settlementId"],
      exportColumns: [
        {
          title: "工号",
          value: "gh",
        },
        {
          title: "姓名",
          value: "fullname",
        },
        {
          title: "证件类型",
          value: "zjlx",
        },
        {
          title: "证件号码",
          value: "id_number",
        },
        {
          title: "国籍(地区)",
          value: "gj",
        },
        {
          title: "性别",
          value: "gender",
        },
        {
          title: "出生日期",
          value: "birthday",
        },
        {
          title: "是否高级专家",
          value: "sfgjzj",
        },
        {
          title: "人员状态",
          value: "ryzt",
        },
        {
          title: "任职受雇从业类型",
          value: "cylx",
        },
        {
          title: "其他情况说明",
          value: "qtqksm",
        },
        {
          title: "入职年度就业情形",
          value: "rzndjyqx",
        },
        {
          title: "手机号码",
          value: "mobile",
        },
        {
          title: "任职受雇从业日期",
          value: "date",
        },
        {
          title: "离职日期",
          value: "lzrq",
        },
        {
          title: "是否残疾",
          value: "sfcj",
        },
        {
          title: "是否烈属",
          value: "sfls",
        },
        {
          title: "是否孤老",
          value: "sfgl",
        },
        {
          title: "残疾证件类型",
          value: "cjzjlx",
        },
        {
          title: "残疾证号",
          value: "cjzh",
        },
        {
          title: "烈属证号",
          value: "lszh",
        },
        {
          title: "是否扣除减除费用",
          value: "sfkckjcfy",
        },
        {
          title: "个人投资额",
          value: "grtze",
        },
        {
          title: "个人投资比例(%)",
          value: "grtzbl",
        },
        {
          title: "备注",
          value: "bz",
        },
        {
          title: "中文名",
          value: "zwm",
        },
        {
          title: "涉税事由",
          value: "sssy",
        },
        {
          title: "出生国家(地区)",
          value: "csgj",
        },
        {
          title: "首次入境时间",
          value: "scrjsj",
        },
        {
          title: "预计离境时间",
          value: "yjljsj",
        },
        {
          title: "其他证件类型",
          value: "qtzjlx",
        },
        {
          title: "其他证件号码",
          value: "qtid_number",
        },
        {
          title: "户籍所在地（省）",
          value: "hjszd_s",
        },
        {
          title: "户籍所在地（市）",
          value: "hjszd_sh",
        },
        {
          title: "户籍所在地（区县）",
          value: "hjszd_qx",
        },
        {
          title: "户籍所在地（详细地址）",
          value: "hjszd_xxdz",
        },
        {
          title: "经常居住地（省）",
          value: "jcjzd_s",
        },
        {
          title: "经常居住地（市）",
          value: "jcjzd_sh",
        },
        {
          title: "经常居住地（区县）",
          value: "jcjzd_qx",
        },
        {
          title: "经常居住地（详细地址）",
          value: "jcjzd_xxdz",
        },
        {
          title: "联系地址（省）",
          value: "lxdz_s",
        },
        {
          title: "联系地址（市）",
          value: "lxdz_sh",
        },
        {
          title: "联系地址（区县）",
          value: "lxdz_qx",
        },
        {
          title: "联系地址（详细地址）",
          value: "lxdz_xxdz",
        },
        {
          title: "电子邮箱",
          value: "dzyx",
        },
        {
          title: "学历",
          value: "xl",
        },
        {
          title: "开户银行",
          value: "khyh",
        },
        {
          title: "银行账号",
          value: "yhzh",
        },
        {
          title: "开户行省份",
          value: "khxsf",
        },
        {
          title: "职务",
          value: "zw",
        },
      ],
      columns: [
        // {
        // 	title: "序号",
        // 	value: "id",
        // },
        {
          title: "服务商名称",
          value: "channel_name",
        },
        {
          title: "姓名",
          value: "fullname",
        },
        {
          title: "证件类型",
          value: "zjlx",
        },
        {
          title: "证件号码",
          value: "id_number",
        },
        {
          title: "国籍(地区)",
          value: "gj",
        },
        {
          title: "性别",
          value: "gender",
        },
        {
          title: "出生日期",
          value: "birthday",
        },
        {
          title: "任职受雇从业类型",
          value: "cylx",
        },
        {
          title: "手机号码",
          value: "mobile",
        },
        {
          title: "任职受雇从业日期",
          value: "date",
        },
      ],
      // 搜索条件
      searchCondition: {
        search: "",
        channel_name: "",
        status: "",
        real_status: "",
        date: "",
      },
      loadingStaus: true,
      // 表格列表数据
      companyList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      options: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      value: "xlsx",
      bookType: "xlsx", //导出表格类型
      downloadLoading: false,
      channelList: [],
      // 选中行数据
      selectedRows: [],
      // 报送状态选项
      declareStatusList: [
        { value: "1", label: "待报送" },
        { value: "2", label: "代报中" },
        { value: "3", label: "代报失败" },
        { value: "4", label: "代报成功" },
      ],
      // 人员验证状态
      verifyStatusList: [
        { value: "1", label: "验证通过" },
        { value: "2", label: "验证不通过" },
        { value: "4", label: "待验证" },
      ],
    };
  },

  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
    disabledDate(time) {
      return time.getTime() > Date.now();
    },

    // 检查必填项（服务商与时间）
    checkTax() {
      let params = this.handleSearchCondition();
      let tip = "";
      if (!params.date) {
        tip = "请选择时间";
      }
      if (!params.channel_name) {
        tip = "请选择服务商";
      }
      if (tip) {
        this.$message.error(tip);
        return false;
      }
      return params;
    },

    // 一键报送
    sbao: debounce(async function() {
      let params = this.checkTax();
      if (params === false) {
        return;
      }

      await this.$api.post_etsEmployeeInfo_declare(params);
      this.$message.success("报送成功");
      this.init();
    }),

    // 一键作废（支持选中行批量作废）
    zuofei: debounce(async function() {
			// 否则按原有逻辑（一键作废全部/按条件）
      let params = this.checkTax();
      if (params === false) {
        return;
      }
      // 如果有选中行，则按选中行批量作废
      if (this.selectedRows && this.selectedRows.length > 0) {
        try {
          await this.$confirm(
            `确认要作废选中的 ${this.selectedRows.length} 条记录吗？`,
            "提示",
            { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
          );
        } catch (e) {
          return; // 取消
        }

        const ids = (this.selectedRows || [])
          .map((r) => r.id || r.employee_id || r.employeeId || r.uid || r.ets_id)
          .filter(Boolean);

        if (!ids.length) {
          this.$message.error("选中行缺少可用标识，无法作废");
          return;
        }

        await this.$api.post_etsEmployeeInfo_cancel({...params,customer_ids: ids });
        this.$message.success("作废成功");
        this.init();
        return;
      }else{
        this.$message.error("请先选择要作废的记录");
			}
    }),
    //导出
    async handleDownload() {
      this.downloadLoading = true;
      let list = await this.init("export");
      if (!list || list.length === 0) {
        this.$message.warning("暂无数据可导出");
        this.downloadLoading = false;
        return;
      }
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = this.exportColumns.map((item) => item.title);
        const data = this.formatJson(list);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `人员信息采集表${time}`;
        excel.export_json_to_excel({
          header: sHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    //转换导出数据
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let tempArr = [];
        this.exportColumns.map((item) => {
          tempArr.push(v[item.value] || "");
        });
        return tempArr;
      });
    },
    //选择导出类型
    selectData(e) {
      this.bookType = e;
    },

    // 搜索
    searchButton() {
      this.init("search");
    },

    // 切换页码操作
    async switchPaging() {
      this.init();
    },

    // 初始化列表
    async init(type) {
      let pagingInfo = this.$refs["apeTable"]?.getPagingInfo(type) || {
        current_page: 1,
        page_size: 10,
      };
      if (type == "export") {
        pagingInfo.page_size = 50000;
        console.log(pagingInfo, "页面对象");
      } else {
        this.loadingStaus = true;
      }
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { data, pages } = await this.$api.get_etsEmployeeInfoList(
        searchCondition
      );

      if (type == "export") {
        return data || [];
      } else {
        this.companyList = [];
        this.$nextTick(() => {
          this.companyList = data || [];
        });
        this.pagingData.total = pages?.total || 0;
        console.log(this.pagingData.total, "总数");
        this.offset = pages?.offset || 0;
        this.loadingStaus = false;
      }
    },

    // 获取服务商账号列表
    async getAccountList() {
      try {
        let { items } = await this.$api.get_qxy_tax_get_account_list({
          current_page: 1,
          page_size: 1000000,
        });
        this.channelList = (items || []).map((item) => {
          return {
            label: item.company_name,
            value: item.id,
          };
        });
      } catch (err) {
        console.error("获取服务商列表失败", err);
      }
    },
    // 获取报送状态标签
    getDeclareLabel(val) {
      const item = (this.declareStatusList || []).find((i) => String(i.value) === String(val));
      return item ? item.label : "-";
    },
    // 获取验证状态标签
    getVerifyLabel(val) {
      const item = (this.verifyStatusList || []).find((i) => String(i.value) === String(val));
      return item ? item.label : "-";
    },
    // 处理搜索条件
    handleSearchCondition() {
			let params = {  };
			for(let key in this.searchCondition){
				if(this.searchCondition[key]){
					params[key] = this.searchCondition[key];
				}
			}
			return params;
    },

    // 处理表格选择变化
    handleSelectionChange(rows) {
			console.log(rows, "选中行数据");
      this.selectedRows = rows || [];
    },

    keyupSubmit() {
      document.onkeydown = (e) => {
        console.log(e);
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
  },
  created() {
    this.keyupSubmit();
  },
  mounted() {
    this.searchCondition.date = moment()
      .subtract(1, "M")
      .format("yyyy-MM");
    this.getAccountList();
    this.init();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-row {
  margin-bottom: 0;
}
.name {
  cursor: pointer;
  color: #409eff;
}
.flex-bw {
  display: flex;
  justify-content: space-between;
}
.btn-box {
  width: 360px;
  flex: none;
}
.table-right {
  float: right;
}
</style>
